import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { useTranslation } from 'react-i18next'

export default function FutureVisualizationPage() {
  const { t } = useTranslation()

  return (
    <FeedbackPage
      emoji="✨"
      heading={t('pages.onboarding.v1.futureVisualization.heading')}
      text={t('pages.onboarding.v1.futureVisualization.text')}
      onSubmit={() => {}}
    />
  )
}
